<template>
    <div class="my-audio" @click.stop>
        <div class="my-audio-setting">
            <a-icon @click="_audio.play()" v-if="!isPlay" type="caret-right"/>
            <a-icon @click="_audio.pause()" v-else type="pause"/>
        </div>
        <div class="my-audio-progress" @click="progress($event)">
            <div :style="`width: ${percentage}%;`"></div>
        </div>
        <div class="my-audio-text">
            {{ currentTime }}/{{ duration }}
        </div>
    </div>
</template>
<script>
    export default {
        props: {
           src: {
               type: String,
           }
        },
        data() {
            return {
                _audio: null,
                duration: "00:00",
                currentTime: "00:00",
                percentage: 0,
                isPlay: false
            };
        },
        mounted() {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', this.src, true);
            xhr.responseType = 'blob';
            xhr.setRequestHeader("Authorization", "Bearer "+ this.$store.getters["account/token"]());
            xhr.send(null);
            xhr.onload = () => {
                this._audio = new Audio();
                this._audio.src = window.URL.createObjectURL(xhr.response);
                this._audio.oncanplay = () => {
                    this.duration = this.zero(Math.floor(this._audio.duration / 60)) + ":" + this.zero(Math.floor(this._audio.duration % 60));
                };
                this._audio.ontimeupdate = () => {
                    this.currentTime = this.zero(Math.floor(this._audio.currentTime / 60)) + ":" + this.zero(Math.floor(this._audio.currentTime % 60));
                    this.percentage = this._audio.currentTime / this._audio.duration * 100;
                };
                this._audio.onpause = () => {
                    this.isPlay = false;
                };
                this._audio.onplay = () => {
                    this.isPlay = true;
                };
            };
        },
        beforeDestroy(){
            this._audio.pause();
        },
        methods: {
            progress(ev) {
                const e = ev || event;
                this._audio.currentTime = e.offsetX / e.target.offsetWidth * this._audio.duration;
                this.percentage = Math.floor(e.offsetX / e.target.offsetWidth * 100);
                this._audio.play();
            },
            zero(n) {
                return n >= 10 ? n : "0" + n;
            }
        },
    };
</script>
<style lang="less">
    .my-audio {
        display: flex;
        align-items: center;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.77);
        padding: 0 20px;

        .my-audio-setting {
            flex-shrink: 0;
            margin-right: 20px;
            color: #fff;
            font-size: 18px;
        }

        .my-audio-progress {
            flex-grow: 1;
            position: relative;
            height: 7px;
            background-color: #ddd;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;

            div {
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                background-color: #25cbcb;
                pointer-events: none;
            }
        }

        .my-audio-text {
            flex-shrink: 0;
            margin-left: 20px;
            color: #999;
        }
    }
</style>
